import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { WarehousePositionForm } from './-form'
import { useCreateWarehousePosition } from '@/hooks/use-warehouse-position-query'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/warehouse-positions/new',
)({
    component: NewWarehousePositionPage,
})

function NewWarehousePositionPage() {
    const navigate = useNavigate()
    const create = useCreateWarehousePosition()

    return (
        <div className="space-y-4 p-4 md:space-y-6 md:p-6">
            <h1 className="text-xl font-semibold">
                {m.warehouse_position_new_title()}
            </h1>
            <WarehousePositionForm
                submitLabel={m.warehouse_position_submit_create()}
                onSubmit={async (data) => {
                    const res = await create.mutateAsync({
                        code: data.code,
                        name: data.name || undefined,
                        applicable_lot_types: data.applicable_lot_types,
                    })
                    const id = res.data?.id
                    if (id) {
                        void navigate({
                            to: '/warehouse-positions/$id',
                            params: { id },
                        })
                    }
                }}
            />
        </div>
    )
}
